import DOMPurify from 'dompurify'

/* @ngInject */
function BriefingsPageController ($scope, $rootScope, $translate, $state, BriefingService, MessageService, SegmentService, UdsModalService, ToastService, $q, ConfirmationModalService) {
  const ANALYTICS_ADVANCED_DASHBOARDS_ACCESS_KEY = 'ANALYTICS.ADVANCED_DASHBOARDS'

  const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')
  const getBindCampaignDialogController = () => import('../../../core/dialogs/bind-campaign/bind-campaign-dialog.controller')

  const getShareWithGuestsDialogController = () => {
    return $q.when(import('../../../core/dialogs/share-with-guests/share-with-guests-dialog.controller'))
  }

  $scope.count = {
    activeBriefings: 0,
    total: 0
  }

  $scope.pagination = {
    top: 100,
    skip: 0
  }

  $scope.briefings = []
  $scope.loading = true

  $scope.companyFeatures = {
    maxBriefings: {
      featureName: '',
      featureSlug: '',
      briefingsLimit: null,
      briefingsLimitReached: false
    },
    notHasAdvancedDashboardsAccess: false
  }

  $scope.pageTitle = ''

  const api = {
    getShareWithGuestsDialogController,
    getUpgradeCompanyPlanDialogController,
    getBindCampaignDialogController,
    _validateCompanyFeatures,
    _getCompanyBriefings,
    _openUpgradeCompanyPlanDialog,
    _getPricingTooltipAndTag,
    _successGetCompanyFeatures,
    _errorGetCompanyFeatures,
    _goBack,
    _setHeader,
    _unbindBriefingFromCampaign,
    _duplicateBriefing,
    _successDuplicateBriefing,
    _errorDuplicateBriefing
  }
  this.getApi = () => api

  function activate () {
    api._getCompanyBriefings()
    api._validateCompanyFeatures()

    $rootScope.getCompanyFeaturesAndAddons()
      .then(api._successGetCompanyFeatures)
      .catch(api._errorGetCompanyFeatures)
  }
  activate()

  $scope.handleEditButton = id => {
    $state.go('admin.workflowBriefing', { id })
  }

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('workflow.briefings')
  })

  $scope.newBriefing = function () {
    if ($scope.companyFeatures.maxBriefings.briefingsLimitReached) {
      api._openUpgradeCompanyPlanDialog({
        featureName: $scope.companyFeatures.maxBriefings.featureName,
        featureSlug: $scope.companyFeatures.maxBriefings.featureSlug
      })
    } else {
      $state.go('admin.workflowBriefingNew')
    }
  }

  $scope.archiveBriefing = id => {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureArchiveBriefing'),
      cancelButton: $translate.instant('no'),
      confirmButton: $translate.instant('yes'),
      press: function () {
        BriefingService.archiveBriefing(id).then(() => {
          activate()
        }).catch(ToastService.defaultErrorToast)
      }
    })
  }

  $scope.unarchiveBriefing = id => {
    if ($scope.companyFeatures.maxBriefings.briefingsLimitReached) {
      api._openUpgradeCompanyPlanDialog({
        featureName: $scope.companyFeatures.maxBriefings.featureName,
        featureSlug: $scope.companyFeatures.maxBriefings.featureSlug
      })
    } else {
      BriefingService.archiveBriefing(id, false).then(() => {
        ToastService.defaultSuccessToast()
        activate()
      }).catch(ToastService.defaultErrorToast)
    }
  }

  $scope.handleDuplicateBriefing = id => {
    if ($scope.companyFeatures.maxBriefings.briefingsLimitReached) {
      api._openUpgradeCompanyPlanDialog({
        featureName: $scope.companyFeatures.maxBriefings.featureName,
        featureSlug: $scope.companyFeatures.maxBriefings.featureSlug
      })
    } else {
      ConfirmationModalService.createModal({
        description: $translate.instant('workflow.duplicateBriefing.confirmationModal.description'),
        buttonConfirmText: $translate.instant('workflow.duplicateBriefing.confirmationModal.buttonConfirmText'),
        onConfirm: () => api._duplicateBriefing(id)
      })
    }
  }

  function _duplicateBriefing (id) {
    return BriefingService.duplicateBriefing(id)
      .then(api._successDuplicateBriefing)
      .catch(api._errorDuplicateBriefing)
  }

  function _successDuplicateBriefing () {
    ToastService.showSuccessToast($translate.instant('workflow.duplicateBriefing.toasts.success'))
    activate()
  }

  function _errorDuplicateBriefing () {
    ToastService.showErrorToast($translate.instant('workflow.duplicateBriefing.toasts.error'))
  }

  $scope.handleOpenAnalytics = (event, slug) => {
    const { pricing } = event.detail

    if (pricing) {
      const featureName = $translate.instant('dataPages.advancedDashboards.featureName')
      const featureSlug = ANALYTICS_ADVANCED_DASHBOARDS_ACCESS_KEY

      return api._openUpgradeCompanyPlanDialog({
        featureName,
        featureSlug
      })
    }

    const analyticsChecklistSlug = 'analytics.dashboard'

    $state.go(analyticsChecklistSlug, {
      slug
    })

    SegmentService.track('workflow-briefing-analytics-btn')

    if (window.clarity) {
      window.clarity('set', 'announcement-preview-results-analytics-btn', null)
    }
  }

  $scope.openBindCampaignDialog = (briefing) => {
    getBindCampaignDialogController().then(({ BindCampaignDialogController }) => {
      const bindCampaignDialog = UdsModalService.createModal({
        controller: BindCampaignDialogController,
        modalName: 'bindCampaignDialog',
        data: {
          currentModule: 'briefings',
          assetId: briefing.id,
          campaignId: briefing.campaignId,
          campaignName: briefing.campaignName
        },
        onClose: (bindDetails) => {
          if (bindDetails) {
            api._unbindBriefingFromCampaign(bindDetails)
          }
        }
      })

      bindCampaignDialog.open()
    })
  }

  function _unbindBriefingFromCampaign (bindDetails) {
    BriefingService.unbindBriefingFromCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        api._getCompanyBriefings()
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _getCompanyBriefings (page = 0) {
    const sort = {
      name: 'isArchived',
      order: 'ASC'
    }

    $scope.pagination.skip = page * $scope.pagination.top
    const { top, skip } = $scope.pagination

    return BriefingService.getCompanyBriefings('WORKFLOW', true, null, top, skip, null, sort).then(briefings => {
      $scope.briefings = briefings.rows
      $scope.activeBriefings = $scope.briefings.filter(briefing => !briefing.isArchived)
      $scope.count.activeBriefings = $scope.activeBriefings.length
      $scope.count.total = briefings.count
      $scope.loading = false
    })
  }

  $scope.getCompanyBriefings = api._getCompanyBriefings

  function _validateCompanyFeatures () {
    BriefingService.validateCompanyFeatures().then(companyFeatures => {
      $scope.companyFeatures = {
        ...$scope.companyFeatures,
        ...companyFeatures
      }

      api._setHeader()
    })

    api._getPricingTooltipAndTag()
  }

  function _getPricingTooltipAndTag () {
    const planId = $rootScope.companyFeaturesAndAddons.id

    if (planId === 1) {
      $scope.maxBriefingsTooltip = $translate.instant('billingTooltips.maxBriefingsLimitPro')
      $scope.maxBriefingsTag = 'Pro'
    } else if (planId === 2) {
      $scope.maxBriefingsTooltip = $translate.instant('billingTooltips.maxBriefingsLimitEnterprise')
      $scope.maxBriefingsTag = 'Enterprise'
    }
  }

  function _openUpgradeCompanyPlanDialog (modalData) {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: modalData
      })

      upgradeCompanyPlanDialog.open()
    })
  }

  function _successGetCompanyFeatures ({ features }) {
    const notHasAnalyticsAdvancedDashboards = !features[ANALYTICS_ADVANCED_DASHBOARDS_ACCESS_KEY]
    const hasWorkflowBriefingsShare = features['SHARE.GUEST']
    const hasCampaignsAccess = features['CAMPAIGNS.ACCESS']

    $scope.companyFeatures.hasWorkflowBriefingsShare = hasWorkflowBriefingsShare
    $scope.companyFeatures.notHasAdvancedDashboardsAccess = notHasAnalyticsAdvancedDashboards
    $scope.companyFeatures.hasCampaignsAccess = hasCampaignsAccess
  }

  function _errorGetCompanyFeatures (error) {
    ToastService.defaultErrorToast()
    console.error(error)
  }

  function _goBack () {
    $state.go('workflow.home')
  }

  function _setHeader () {
    $scope.headerNavigation = {
      buttons: [{
        type: 'button',
        btnType: 'primary',
        label: $translate.instant('add'),
        icon: 'plus',
        onClick: $scope.newBriefing,
        pricing: {
          prop: $scope.companyFeatures.maxBriefings.briefingsLimitReached,
          tooltip: $scope.maxBriefingsTooltip,
          position: 'left'
        },
        disabled: $scope.companyFeatures.maxBriefings.briefingsLimitReached
      }],
      backButton: {
        onClick: api._goBack
      }
    }
  }

  $scope.openShareBriefingModal = id => {
    api.getShareWithGuestsDialogController().then(({ ShareWithGuestsDialogController }) => {
      const shareWithGuestsDialog = UdsModalService.createModal({
        controller: ShareWithGuestsDialogController,
        modalName: 'shareWithGuestsDialog',
        data: {
          id: id,
          itemType: 'briefing'
        }
      })
      shareWithGuestsDialog.open()
    })
  }

  $scope.getDescription = (description) => {
    return DOMPurify.sanitize(description, { ALLOWED_TAGS: [] })
  }
}

export { BriefingsPageController }
